
(() => {
  const KEY = 'sa_wishlist_v1';
  const LIMIT = 100;

  const read = () => {
    try {
      const raw = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(raw) ? raw.map(Number).filter(Number.isFinite) : [];
    } catch (_) {
      return [];
    }
  };

  const write = (ids) => {
    try { localStorage.setItem(KEY, JSON.stringify(ids.slice(-LIMIT))); }
    catch (_) {  }
  };

  const Wishlist = {
    get items() { return read(); },
    has(id) { return read().includes(Number(id)); },

    toggle(id) {
      const numId = Number(id);
      if (!Number.isFinite(numId)) return false;
      const ids = read();
      const idx = ids.indexOf(numId);
      if (idx === -1) ids.push(numId); else ids.splice(idx, 1);
      write(ids);
      this.sync();
      window.PubSub.publish('wishlist:change', { items: ids, id: numId, added: idx === -1 });
      return idx === -1;
    },

    clear() { write([]); this.sync(); this.renderGrid(); },

    sync() {
      const ids = read();
      const s = window.themeStrings || {};
      document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
        const active = ids.includes(Number(btn.dataset.wishlistToggle));
        btn.setAttribute('aria-pressed', String(active));
        btn.classList.toggle('is-active', active);
        const label = active ? s.wishlistRemove : s.wishlistAdd;
        if (label) btn.setAttribute('aria-label', label);
      });
      document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
        el.textContent = ids.length;
        el.toggleAttribute('hidden', ids.length === 0);
      });

      document.querySelectorAll('[data-wishlist-clear]').forEach((el) => {
        el.toggleAttribute('hidden', ids.length === 0);
      });
    },

    async renderGrid() {
      const grid = document.querySelector('[data-wishlist-grid]');
      if (!grid) return;
      const ids = read();

      const run = (this._renderToken = (this._renderToken || 0) + 1);

      if (!ids.length) {

        const tpl = document.querySelector('template[data-wishlist-empty]');
        grid.innerHTML = tpl
          ? tpl.innerHTML
          : `<li class="wishlist__empty">${grid.dataset.emptyText || ''}</li>`;
        return;
      }

      grid.classList.add('is-loading');
      try {
        const q = ids.map((id) => `id:${id}`).join(' OR ');
        const url = `${window.routes.search_url}?type=product&options[unavailable_products]=last`
          + `&q=${encodeURIComponent(q)}&section_id=wishlist-items`;
        const res = await fetch(url);
        const text = await res.text();
        if (run !== this._renderToken) return; 
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const fresh = doc.querySelector('[data-wishlist-items]');
        grid.innerHTML = fresh ? fresh.innerHTML : '';
      } catch (e) {
        console.error('[wishlist] render failed', e);
      } finally {
        if (run === this._renderToken) {
          grid.classList.remove('is-loading');
          this.sync();
        }
      }
    },
  };

  window.Wishlist = Wishlist;

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    Wishlist.toggle(btn.dataset.wishlistToggle);
  });

  window.PubSub.subscribe('wishlist:change', ({ id, added }) => {
    const grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;

    if (added) { Wishlist.renderGrid(); return; }

    const card = grid.querySelector(`[data-wishlist-card="${id}"]`);
    if (!card) return;
    card.closest('li')?.remove();
    if (!grid.querySelector('[data-wishlist-card]')) Wishlist.renderGrid();
  });

  const init = () => { Wishlist.sync(); Wishlist.renderGrid(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.addEventListener('storage', (e) => { if (e.key === KEY) init(); });
  document.addEventListener('shopify:section:load', () => Wishlist.sync());
})();
